import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/confronto/lexaipro-vs-ricerca-manuale")({
  head: () => seoMeta({
    title: "LexAIPro vs ricerca legale manuale: tempo risparmiato",
    description: "Quanto tempo si risparmia usando LexAIPro rispetto alla ricerca tradizionale su banche dati e codici cartacei.",
    path: "/confronto/lexaipro-vs-ricerca-manuale",
  }),
  component: () => (
    <ContentPage
      eyebrow="Confronto"
      title="LexAIPro vs ricerca legale manuale"
      lead="Una ricerca giurisprudenziale che richiede 45 minuti su banche dati tradizionali si conclude in meno di 90 secondi con LexAIPro, citazioni incluse."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Confronto",path:"/confronto/lexaipro-vs-ricerca-manuale"},{name:"vs Ricerca manuale",path:"/confronto/lexaipro-vs-ricerca-manuale"}]}
      sections={[
        { heading: "Tempi medi misurati", bullets: ["Ricerca normativa: -85% di tempo","Sintesi di un atto: -90%","Prima bozza di un contratto: -75%","Estrazione clausole: -95%"] },
        { heading: "Cosa non cambia", body: "Il giudizio del professionista. LexAIPro accelera la fase istruttoria; la decisione resta tua." },
      ]}
      cta={{ label: "Prova la differenza", to: "/signup" }}
      heroImage={pickContent(44)}
      updated="2026"
    />
  ),
});
